import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const styles = (theme) => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginTop: "20px",
    width: "50%"
  }
});
class Input extends Component {
  render() {
    const {
      label,
      type,
      value,
      onChange,
      maxLength,
      classes,
      multiline,
      rowsMax
    } = this.props;
    const inputProps = {
      multiline: label,
      maxLength: maxLength
    };
    return (
      <TextField
        type={type}
        label={label}
        name={label}
        value={value}
        onChange={onChange}
        className={classes.textField}
        inputProps={inputProps}
        multiline={multiline}
        rowsMax={rowsMax}
      />
    );
  }
}
Input.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
  maxLength: PropTypes.string,
  multiline: PropTypes.bool,
  rowsMax: PropTypes.number
};

export default withStyles(styles)(Input);
